<template>
<div class="wrapper">
  <v-sidebar activeNavItem="rfq-testing"></v-sidebar>
    <div class="main-panel">
      <v-navbar :title="'Map'"></v-navbar>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col col-4 rfq-list">
                Dispatched RFQs
              <button @click="() => copyCosts()">
                Migrate Costs
              </button>
              <button @click="() => setAssigneeCreatedAt()">
                Migrate Assignees CreatedAt Dates
              </button>
              <ul>
                <li class="rfq-li" v-for="(rfq, index) of availableRFQs" :key="index" @click="() => loadRFQPoints(rfq)">
                  <div>
                    {{ rfq.customer.company }} ({{ rfq.dispatchStatus }})
                  </div>
                  <div>
                    <button class="btn btn-sm" @click="() => dispatchDummyTracker(rfq)">
                      Send Dummy Tracker Data
                    </button>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col col-8">
              <LeafletMap fit-to-markers height="600px" :points="selectedRFQPoints" :polygons="selectedRFQPolygons" :lines="selectedRFQLines" />
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>
<script>

import Vue from 'vue';
import apiService from '../../services/api.service';
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'

import LeafletMap from '../map/LeafletMap.vue';
import config from '../../config';
    
export default {
  name: 'RFQTesting',
  components:{
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    LeafletMap,
  },
  data(){
    return {
      availableRFQs: [],
      selectedRFQ: null,
      selectedTrackingPoints: [],
    };
  },
  computed: {
    selectedRFQPoints(){
      if(this.selectedRFQ === null) return [];
      return [
        ...this.selectedTrackingPoints,
        {
          center: this.selectedRFQStartPoint,
          popup: "Pickup",
          popupAutoOpen: true,
          icon:{
            prefix: 'fa',
            icon: 'level-up',
            color: 'blue',
          }
        },
        {
          center: this.selectedRFQEndPoint,
          popup: "Delivery",
          popupAutoOpen: true,
          icon:{
            prefix: 'fa',
            icon: 'level-down',
            color: 'blue',
          }
        },
      ]
    },
    selectedRFQLines(){
      if(this.selectedRFQ === null) return [];
      return [{
        pointList: this.selectedTrackingPoints.map(point => {
          return [point.center.lat, point.center.lng]
        }),
        options:{
          color: 'red',
          weight: 3,
          opacity: 0.5,
          smoothFactor: 1
        },
      }]
    },
    selectedRFQPolygons(){
      if(this.selectedRFQ === null) return [];
      return [
        {
          type: 'circle',
          center: this.selectedRFQStartPoint,
          options:{
            color: 'red',
            fillColor: '#f03',
            fillOpacity: 0.2,
            radius: 500, // 500m
          }
        },
        {
          type: 'circle',
          center: this.selectedRFQEndPoint,
          options:{
            color: 'red',
            fillColor: '#f03',
            fillOpacity: 0.2,
            radius: 500, // 500m
          },
        }
      ];
    },
    selectedRFQStartPoint(){
      if(this.selectedRFQ === null) return [];
      const coords = this.selectedRFQ.shipper.addressCoordinates;
      return [coords.lat, coords.lng];
    },
    selectedRFQEndPoint(){
      if(this.selectedRFQ === null) return [];
      const coords = this.selectedRFQ.consignee.addressCoordinates;
      return [coords.lat, coords.lng];
    }
  },
  mounted(){
    this.loadAvailableRFQs();
  },
  methods:{
    async loadAvailableRFQs(){
      const response = await apiService.get('/rfq/list');
      this.availableRFQs = response.data.result.filter(x => x.dispatch);
    },
    async loadRFQPoints(rfq){
      console.log("loadRFQPoints", rfq);
      this.selectedRFQ = rfq;
    },
    async copyCosts(rfq){
      await apiService.get('/kong/api/v1/rfq/copyQuoteFinalMarkedUpCost');
      console.log("Costs copied");
    },
    async setAssigneeCreatedAt(rfq){
      await apiService.get('/kong/api/v1/rfq/setAssigneeCreatedAt');
      console.log("CreatedAt dates set");
    },
    async dispatchDummyTracker(rfq){
      try{
        const response = await apiService.post(`/rfq/${rfq._id}/sendDummyTrackerData`, {});
        this.selectedTrackingPoints = response.data.result.map(point => {
          return  {
            center: {
              lat: point.latitude,
              lng: point.longitude,
            },
            icon: {
              prefix: 'fa',
              icon: 'truck',
              markerColor: 'red'
            }
          };
        });
      }catch(error){
        console.error(error);
        this.selectedTrackingPoints = [];
        Vue.toasted.error(`The RFQ Must be dispatched`, { duration: 3500 });
      }
    }
  }
}
</script>
<style scoped>
.rfq-list{
  overflow: auto;
  max-height: 600px;
  padding: 0;
  margin: 0;
}
.rfq-list > ul{
  list-style: none;
  font-size: 0.8rem;
  margin: 0;
  padding: 0;
}
.rfq-list > ul > li{
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// RFQTesting.vue?bd7a0d8e